import { render, staticRenderFns } from "./FormSectionHeader.vue?vue&type=template&id=48c822ce&scoped=true&"
import script from "./FormSectionHeader.vue?vue&type=script&lang=js&"
export * from "./FormSectionHeader.vue?vue&type=script&lang=js&"
import style0 from "./FormSectionHeader.vue?vue&type=style&index=0&id=48c822ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c822ce",
  null
  
)

export default component.exports